import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';

import ManageMembersModal from 'zComponents/molecules/ManageMembersModal';
import { Button, Col, Row, Tooltip } from 'zui/Antd';

const MembersPanelExtra = ({ teamID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canManageMembers = useManagePermittedRoles('manageMembers');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canManageMembers) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('members')) {
			setActiveKeys([...activeKeys, 'members']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('members')) {
					return [...prev, 'members'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canManageMembers ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canManageMembers}
						/>
					</span>
				</Tooltip>
				<ManageMembersModal visible={openModal} setVisible={handleCloseModal} teamID={teamID}>
					<div />
				</ManageMembersModal>
			</Col>
		</Row>
	);
};

export default MembersPanelExtra;
